import React from 'react'
import * as S from './ReceivementField.styles'

interface Props {
    field: string;
    value: string
}

const ReceivementField = ({
  field, value,
}: Props) => (
  <S.Field>
    {field}
    <S.FieldValue>{value}</S.FieldValue>
  </S.Field>
)

export { ReceivementField }
